import React from "react";
import { Link } from "gatsby";
import { motion } from "framer-motion";
import { InView } from "react-intersection-observer";
import ContactForm from "../pages/contact/form";

const Partners = class extends React.Component {
  render() {
    return (
      <section className="home-contact">
        <InView threshold={0.2}>
            {({ ref, inView }) => (
              <motion.div
                ref={ref}
                initial={{ opacity: 0, transform: "translate(-50px)" }}
                animate={
                  inView
                    ? { opacity: 1, transform: "translate(0px)" }
                    : { opacity: 0 }
                }
                transition={{
                  type: "spring",
                  stiffness: 100,
                  duration: 3,
                  delay: 0.25,
                }}
                className="testimonial"
              >
          <p className="yellow-text">Don’t just take our word for it</p>
          <p className="testimonial-text">
          <span className="highlight">"</span>Partnering with Nathan has definitely been a great choice. He has since demonstrated what a talented recruitment partner he is, always delivering great candidates & ensuring to provide a first class candidate experience as well. Looking forward to the success of this partnership.<span className="highlight">"</span> 
          </p>
          <p className="yellow-text">Laura De Jaen</p>
          <p className="white-text">(Talent Manager) - Social Point</p>
          </motion.div>
            )}
          </InView>
        <div className="contact-form-small" id="contact-form">
        <ContactForm />
        </div>
      </section>
    );
  }
};

export default Partners;
